import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { CardHistory } from '@models/card-settings-history/card-history.model';

import { QueryConfig } from '@app/shared/utils/query-config.utils';
import { PagedResponse } from '@models/commons/paged-response.model';
import { AppUtils } from '@app/shared/utils/app.utils';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CardSettingsHistoryService {
  static readonly API_CARDS_BASE_PATH = `${environment.api.rest.cards}`;

  constructor(private http: HttpClient) {
  }

  loadCardSettingsHistory(config: QueryConfig): Observable<PagedResponse<CardHistory>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get<PagedResponse<CardHistory>>(`${CardSettingsHistoryService.API_CARDS_BASE_PATH}/history`, {params});
  }

  downloadCardSettingsHistoryReport(config: QueryConfig): Observable<HttpResponse<Blob>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get(`${CardSettingsHistoryService.API_CARDS_BASE_PATH}/history-file`, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }
}
